(() => {
  const STORAGE_KEY = 'agtech_attribution';
  const PARAM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];

  const readAttribution = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) || null;
    } catch (error) {
      return null;
    }
  };

  const captureAttribution = () => {
    const stored = readAttribution();
    // First touch wins for the session; only fill in when nothing is stored yet.
    if (stored) return stored;

    const params = new URLSearchParams(window.location.search);
    const attribution = {
      landing_page: window.location.pathname + window.location.search,
    };
    PARAM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) attribution[key] = value.slice(0, 200);
    });

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (error) {
      // Storage unavailable (private mode); attribution is still used for this page.
    }
    return attribution;
  };

  const fillAttributionFields = (attribution) => {
    document.querySelectorAll('.js-attribution-field').forEach((input) => {
      const value = attribution[input.dataset.attributionKey];
      if (value && !input.value) input.value = value;
    });
  };

  const init = () => fillAttributionFields(captureAttribution());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
